/** Product lifecycle — align with planned API enums */
export const PRODUCT_STATUS = {
  DRAFT: "draft",
  INTERNAL_REVIEW: "internal_review",
  SCHEDULED: "scheduled",
  PUBLISHED: "published",
  OUT_OF_STOCK: "out_of_stock",
  UNPUBLISHED: "unpublished",
  ARCHIVED: "archived",
};

export const STOCK_STATUS = {
  IN_STOCK: "in_stock",
  LOW_STOCK: "low_stock",
  OUT_OF_STOCK: "out_of_stock",
  PRE_ORDER: "pre_order",
};

export const ORDER_STATUS = {
  SUBMITTED: "submitted",
  PENDING_PAYMENT: "pending_payment",
  AWAITING_CONFIRMATION: "awaiting_confirmation",
  CONFIRMED: "confirmed",
  PROCESSING: "processing",
  READY_FOR_PICKUP: "ready_for_pickup",
  SHIPPED: "shipped",
  DELIVERED: "delivered",
  COMPLETED: "completed",
  DECLINED: "declined",
  CANCELLED: "cancelled",
};

export const PARTICIPANT_TYPE = {
  STANDALONE_INVESTOR: "standalone_investor",
  COOPERATIVE_MEMBER: "cooperative_member",
};

export const PRODUCT_STATUS_COLORS = {
  draft: "#A1A0A0",
  internal_review: "#0556e5",
  scheduled: "#8543f1",
  published: "#19BC31",
  out_of_stock: "#FF4343",
  unpublished: "#FFA500",
  archived: "#383838",
};

export const STOCK_STATUS_COLORS = {
  in_stock: "#19BC31",
  low_stock: "#ff9500",
  out_of_stock: "#FF4343",
  pre_order: "#31778C",
};

export const ORDER_STATUS_COLORS = {
  submitted: "#FFA500",
  pending_payment: "#ff9500",
  awaiting_confirmation: "#ff9500",
  confirmed: "#0556e5",
  processing: "#31778C",
  ready_for_pickup: "#8543f1",
  shipped: "#31778C",
  delivered: "#19BC31",
  completed: "#19BC31",
  declined: "#FF4343",
  cancelled: "#A1A0A0",
};

export const NEEDS_ATTENTION_SEVERITY = {
  critical: { bg: "rgba(255, 67, 67, 0.08)", border: "#FF4343", text: "#FF4343" },
  warning: { bg: "rgba(255, 149, 0, 0.08)", border: "#ff9500", text: "#da6900" },
  info: { bg: "rgba(49, 119, 140, 0.08)", border: "#31778C", text: "#31778C" },
  neutral: { bg: "#f7f7f7", border: "#e0e0e0", text: "#525252" },
};

export const PRODUCT_EDITOR_STEPS = [
  { key: "basic", label: "Basic Information" },
  { key: "pricing", label: "Pricing & Units" },
  { key: "inventory", label: "Inventory" },
  { key: "content", label: "Public Content" },
  { key: "media", label: "Media & Delivery" },
  { key: "review", label: "Review & Publish" },
];

export const ORDER_QUEUE_TABS = [
  { key: "", label: "All" },
  { key: "submitted", label: "Submitted" },
  { key: "pending_payment", label: "Awaiting Payment" },
  { key: "awaiting_confirmation", label: "Awaiting Confirmation" },
  { key: "confirmed", label: "Confirmed" },
  { key: "processing", label: "Processing" },
  { key: "ready_for_pickup", label: "Ready for Pickup" },
  { key: "shipped", label: "Shipped" },
  { key: "delivered", label: "Delivered" },
  { key: "completed", label: "Completed" },
  { key: "declined", label: "Declined" },
  { key: "cancelled", label: "Cancelled" },
];
